import customCss from "./customCss";
import markdownRenderer from "./markdownRenderer";

import handlePartialSend from "../form_events/handlePartialSend";
import handleComplete from "../form_events/handleComplete";
import handleAfterRenderQuestion from "../form_events/handleAfterRenderQuestion";
import handleDropdownLazyLoad from "../form_events/handleDropdownLazyLoad";

export default (survey, config) => {
  try {
    applyInitialSetup(survey, config);
    setupEventHandlers(survey, config);
  } catch (error) {
    console.error("Error in survey setup:", error);
  }
};

function applyInitialSetup(survey, config) {
  survey.css = customCss;
  survey.showProgressBar = false;
  survey.sendResultOnPageNext = true;

  if (isDealStage(config.defaultResponse)) {
    survey.completedHtml = generateDealCompletedHtml();
  }

  applyResponseData(survey, config.responseData);
  markdownRenderer(survey);
}

function setupEventHandlers(survey, config) {
  survey.onPartialSend.add(() => handlePartialSend(survey, config));
  survey.onComplete.add(() => handleComplete(survey, config));
  survey.onAfterRenderQuestion.add((survey, options) =>
    handleAfterRenderQuestion(survey, options, config)
  );
  survey.onChoicesLazyLoad.add(handleDropdownLazyLoad);
}

function isDealStage(defaultResponse) {
  if (defaultResponse !== undefined && defaultResponse !== null) {
    return defaultResponse["dashboard_stage"] == "deal";
  } else {
    return false;
  }
}

function applyResponseData(survey, responseData) {
  if (responseData && Object.keys(responseData).length > 0) {
    survey.data = responseData;
    if (responseData.pageNo !== undefined) {
      survey.currentPageNo = responseData.pageNo;
    }
  }
}

function generateDealCompletedHtml() {
  return `
      <h3>Thank you for completing your paperwork ahead of time</h3>
      <p>
        This will save you time when your loved one passes. At that time we will ask you 
        to return to your dashboard to review your answers and provide additional information 
        on the passing.
      </p>
      <p>
        We are here to support you and your family throughout this time, so please don’t hesitate 
        to call or email if you have any questions.
      </p>
      <p>
        For now, you can click on the button below to return to your dashboard.
      </p>
    `;
}
